import {createSlice} from '@reduxjs/toolkit';
import {dismissUserAnnouncement, getUserAnnouncements} from './actions';
import {EmployeeCommunicationState} from './types';

const initialState: EmployeeCommunicationState = {
  loadingStatus: 'NotLoaded',
  announcements: [],
};

const slice = createSlice({
  name: 'employeeCommunication',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserAnnouncements.pending, (state) => {
        state.loadingStatus = 'Loading';
      })
      .addCase(getUserAnnouncements.fulfilled, (state, action) => {
        state.announcements = action.payload;
        state.loadingStatus = 'Loaded';
      })
      .addCase(getUserAnnouncements.rejected, (state) => {
        state.loadingStatus = 'Failed';
      })

      .addCase(dismissUserAnnouncement.pending, (state) => {
        state.loadingStatus = 'Loading';
      })
      .addCase(dismissUserAnnouncement.fulfilled, (state, action) => {
        state.loadingStatus = 'Loaded';
      })
      .addCase(dismissUserAnnouncement.rejected, (state) => {
        state.loadingStatus = 'Failed';
      });
  },
});

export const {reducer: employeeCommunicationReducer} = slice;
